import { ReactElement } from 'react';
import ModalImg from 'src/assets/images/create-menu-item-modal.png';
import { Modal } from '@weareopenr/component-library';
import ChannelRuleModalContent from './ChannelRuleModalContent';
import { useExternalSystems } from 'src/hooks/useExternalSystems';
import { IPriceRule } from 'src/types/price.types';

interface ChannelRuleModalProps {
  closeModal: () => void;
  open: boolean;
  priceSchemeId: string;
  priceRuleToEdit?: IPriceRule;
  step?: number;
}

export const ChannelRuleModal = ({
  closeModal,
  open,
  priceSchemeId,
  priceRuleToEdit,
  step,
}: ChannelRuleModalProps): ReactElement => {
  const { data: channels = [] } = useExternalSystems();

  return (
    <Modal closeModal={closeModal} open={open} image={ModalImg} imageAlt="Picture of ingredient">
      <ChannelRuleModalContent
        priceRuleToEdit={priceRuleToEdit}
        priceSchemeId={priceSchemeId}
        defaultStep={step}
        channels={channels}
        closeModal={closeModal}
      />
    </Modal>
  );
};
